import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-view-kit',
  templateUrl: './view-kit.component.html',
  styleUrls: ['./view-kit.component.css']
})
export class ViewKitComponent implements OnInit {

  constructor(
    @Inject(MAT_DIALOG_DATA) public kit: any,
    public dialogRef: MatDialogRef<ViewKitComponent>
  ) { }

  ngOnInit(): void {
  }

}
